var bridge = {
    site: {
        reporting: ["tsltescouk"],
        internalDomains: ["tes.co.uk", "tesforteachers.com"],
        qsExclusionsList: [
            "cid",
            "s_cid"
        ]
    },
    user: {
        id: ""
    },
    page: {
        type: "resource",
        sections: ["teachingresources"],
        pnExclusion: "teyrtewrtwu"
    },
    products: [],
    utils: []
};
bridge.page.title = document.title.replace(' - Resources - TES', '');
